import { render, staticRenderFns } from "./Family.vue?vue&type=template&id=4b09e7ae&scoped=true"
import script from "./Family.vue?vue&type=script&lang=ts"
export * from "./Family.vue?vue&type=script&lang=ts"
import style0 from "./Family.vue?vue&type=style&index=0&id=4b09e7ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b09e7ae",
  null
  
)

export default component.exports